import React from 'react'

import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import * as S from './styles'

/**
 * Renders a group of two buttons: a cancel button and a confirm button.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.confirmAction - The function to be called when the confirm button is clicked.
 * @param {Function} props.cancelAction - The function to be called when the cancel button is clicked.
 * @param {string} [props.cancelLabel='cancelar'] - The text to display on the cancel button.
 * @param {string} [props.confirmLabel='aplicar'] - The text to display on the confirm button.
 * @param {boolean} [props.confirmDisabled=false] - Whether the confirm button should be disabled.
 * @returns {React.Element} A React element containing two buttons wrapped in a styled component.
 */
function ButtonGroup({
  confirmAction,
  cancelAction,
  cancelLabel = 'cancelar',
  confirmLabel = 'aplicar',
  confirmDisabled = false,
}) {
  return (
    <S.Wrapper>
      <Button variant="text" color="primary" onClick={cancelAction} data-testid="cancelled-action-button">
        {cancelLabel}
      </Button>
      <Button
        style={{ color: '#FFF' }}
        variant="contained"
        color="primary"
        disabled={confirmDisabled}
        onClick={confirmAction}
        data-testid="confirmed-action-button"
      >
        {confirmLabel}
      </Button>
    </S.Wrapper>
  )
}

ButtonGroup.propTypes = {
  confirmAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  confirmDisabled: PropTypes.bool,
}

ButtonGroup.defaultProps = {
  cancelLabel: 'cancelar',
  confirmLabel: 'aplicar',
  confirmDisabled: false,
}

export default ButtonGroup
